import { memo, useMemo } from 'react';

import AppQueryBuilder from '../AppQueryBuilder';
import { COMBINATOR, FIELD, OPERATORS } from '../AppQueryBuilder/constants';

function GroupQueryBuilder({ options, query, handleQueryChange }) {
  const fields = useMemo(() => [
    {
      name: FIELD.NAME,
      label: FIELD.LABEL,
      operators: OPERATORS,
      valueEditorType: 'select',
      values: options
    }
  ], [options]);
  const defaultValue = options?.at(0)?.value;
  const defaultQuery =  useMemo(() => ({
    combinator: query.combinator || COMBINATOR.AND,
    rules: query.rules || [{ field: 'name', operator: '=', value: defaultValue }]
  }), [query, defaultValue]);

  return <AppQueryBuilder defaultQuery={defaultQuery} fields={fields} handleQueryChange={handleQueryChange} />;
}

export default memo(GroupQueryBuilder);
